import { createSelector } from 'reselect';

import { PcodeRenderDataCanvas } from '../../../typings/pcode';
import { Bundle } from '../../common/requestsTypings';
import { CreativeOptionsData } from '../../CreativeOptions/typings';
import { getCommonPcodeRenderData } from '../AddCommonCreative/helpers';
import { AddAdaptiveCreativeState, CommonCreativeItem } from '../typings';

export const selectPcodeData = createSelector(
    (state: AddAdaptiveCreativeState) => state.item,
    (state: AddAdaptiveCreativeState) => state.creativeOptions,
    (state: AddAdaptiveCreativeState) => state.bundle,
    (
        item?: CommonCreativeItem,
        creativeOptions?: CreativeOptionsData,
        bundle?: Bundle
    ): PcodeRenderDataCanvas | undefined => {
        if (!creativeOptions || !bundle || !item) {
            return undefined;
        }

        return getCommonPcodeRenderData(item, creativeOptions, bundle);
    }
);
